/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Usage_Status_Headline_MaxedInputs */



/**
* | output |
* | --- |
* | "You've reached your {max} limit this billing period." |
*
* @param {Usage_Status_Headline_MaxedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_status_headline_maxed = /** @type {((inputs: Usage_Status_Headline_MaxedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Status_Headline_MaxedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Sie haben Ihr Limit von ${i?.max} in dieser Abrechnungsperiode erreicht.`)
	return /** @type {LocalizedString} */ (`You've reached your ${i?.max} limit this billing period.`)
});